const config = {
	api: 'https://meal.omybox.com/grb/api',
	appPath: '/grb/app',
	loginTimeout: 18000000,
	contact: {
		// email: 'sample@email.com',
		phone: '+852 2325-2533'
		// address: 'Sample Address'
	}
};

export default config;
